<template>
  <div v-if="hasAttributes" qaid="product-attributes-container" class="mb-4 w-full">
    <component
      :is="getAttributeComponent(attribute)"
      v-for="attribute in product.variantAttributesDirectory"
      :key="`${attribute.code}-${product.code}`"
      :code="attribute.code"
      :product="product"
      :selected-variant="selectedVariant"
      :init-attribute-selection="initAttributeSelection"
      :stock-message="stockMessage"
      :label="attribute.displayName"
      :attribute="getAttributeOptions(attribute)"
      :selected-attributes="selectedAttributes"
      :update-selected-attributes="updateSelectedAttributes"
      class="mb-2"
      @color-changed="
        (color) => {
          $emit('color-changed', color);
        }
      "
    >
    </component>
  </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
import AttributeColor from '@/components/containers/buy-zone/attributes/AttributeColor.vue';
import AttributeDropdown from '@/components/containers/buy-zone/attributes/AttributeDropdown.vue';
import ProductAttributeButtonGrid from '@/components/containers/buy-zone/attributes/ProductAttributeButtonGrid.vue';
import {getSelectedVariant} from '@/utils/variant-helpers.js';

const Attributes = {
  dropdown: AttributeDropdown,
  swatch: AttributeColor,
  radio: ProductAttributeButtonGrid,
};

export default {
  name: 'ProductAttributesContainer',
  components: {
    AttributeColor,
    AttributeDropdown,
    ProductAttributeButtonGrid,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    initAttributeSelection: {
      type: Object,
      default: () => null,
    },
    modelValue: {
      type: String,
      default: '',
    },
    stockMessage: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      selectedAttributes: {},
      selectedVariant: {},
      productDetailsSwatchSelector: 'swatches-swatch',
    };
  },

  computed: {
    ...mapState('productDetails', ['selectedColor']),
    ...mapState('familyDetails', ['models']),

    hasAttributes() {
      return this.product && this.product.variantAttributesDirectory.length > 0;
    },
  },
  watch: {
    initAttributeSelection() {
      this.updateSelectedAttributes(this.initAttributeSelection);
    },
    selectedColor(newValue, oldValue) {
      if (oldValue && newValue !== oldValue) {
        this.$nextTick(() => {
          const selectedSwatch = document.querySelector(`#${this.productDetailsSwatchSelector}-${newValue}`);
          selectedSwatch?.click();
        });
      }
    },
  },
  mounted() {
    this.updateSelectedAttributes(this.initAttributeSelection);
  },
  methods: {
    ...mapMutations('savedLists', ['setBuyingZoneEntries']),

    getAttributeComponent(attribute) {
      return Attributes?.[attribute?.type] ?? Attributes.dropdown;
    },
    getAttributeOptions(attribute) {
      return attribute.options.map((option) => {
        return {
          ...attribute,
          ...option,
        };
      });
    },
    updateSelectedAttributes(selectedAttributes) {
      let validatedAttributes = {};

      Object.keys(selectedAttributes).forEach((code) => {
        const hasValidAttributeCode = this.product.variantAttributesDirectory.find(
          (attribute) => attribute.code === code
        );

        if (hasValidAttributeCode) {
          validatedAttributes[code] = selectedAttributes[code];
        }
      });

      this.selectedAttributes = {
        ...this.selectedAttributes,
        ...validatedAttributes,
      };

      const variant = getSelectedVariant({product: this.product, selectedAttributes: this.selectedAttributes});
      if (variant?.code) {
        let attribute = Object.keys(selectedAttributes)[0];
        this.$emit('attribute-selected', selectedAttributes[attribute]);
        this.$emit('update:modelValue', variant.code);
        this.setBuyingZoneEntries([{sku: variant.code, qty: 1}]);
      } else {
        this.$emit('update:modelValue', null);
      }

      this.selectedVariant = variant;
    },
  },
};
</script>
